/**
 * 将多个多语言拼接，用于处理多个字符在非中文显示的缺失空格的问题
 *
 * @param args Obtain the multilingual set that needs to be transformed. 获取需要转换的多语言集合。
 */
import i18n from "@/i18n"; // 按需加载

export function multipleJoinString(...args) {
    const currentLang = i18n.global.locale;

    return currentLang === 'zh-CN' ? args.join('') : args.join(' ');
}

// export function t (keys) {
//     const currentLang = i18n.global.locale;
//
//     return i18n.global.messages[currentLang][keys]
// }

export function t(keys, params) {
    const currentLang = i18n.global.locale;
    let translation = i18n.global.messages[currentLang][keys];

    if (params) {
        Object.keys(params).forEach(key => {
            const regex = new RegExp(`{${key}}`, 'g');
            translation = translation.replace(regex, params[key]);
        });
    }

    return translation;
}

/**
 * 首字母大写
 *
 * @param str Obtain the multilingual set that needs to be transformed. 获取需要转换的多语言集合。
 */
export function capitalizeFirstLetter (str) {
    if (!str || str.length === 0) return str; // 如果字符串为空或非字符串，直接返回

    return str.charAt(0).toUpperCase() + str.slice(1);
}
export function capitalizeLetter (str) {
    if (!str || str.length === 0) return str; // 如果字符串为空或非字符串，直接返回

    return str.toUpperCase();
}


